import React from "react";
import PropTypes from "prop-types";

import axios from 'axios'
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// core components
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";

import { startSetCarriersList } from "store/actions/adminActions"

class Form extends React.Component {
    state = {
        comment: '',
        messageSent: false,
        messageError: false,
    }
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden"
        };
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }

    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
       console.log(this.props.orderID)
    //console.log(this.props.authUser.uid)
        db.collection("orders").doc(this.props.orderID).set({
            status: "dispatched",
            pickUpCarrier: this.state.pickUpCarrier,
            dropOffCarrier: this.state.dropOffCarrier,
            comment: this.state.comment,
            updatedAt: new Date()
        }, { merge: true }).then((e) => {
            //console.log(this.props.authUser.uid)
            db.collection("TEST-users").doc(this.props.authUser.uid).collection("orders").doc(this.props.orderID).set({
                status: "dispatched",
                pickUpCarrier: this.state.pickUpCarrier,
                dropOffCarrier: this.state.dropOffCarrier,
                comment: this.state.comment,
                updatedAt: new Date()
            }, { merge: true }).then(() => {
                //console.log("sent to shipper:" + this.props.shipperID)
                db.collection("TEST-users").doc(this.props.shipperID).collection("orders").doc(this.props.orderID).set({
                    status: "dispatched",
                    pickUpCarrier: this.state.pickUpCarrier,
                    dropOffCarrier: this.state.dropOffCarrier,
                    comment: this.state.comment,
                    updatedAt: new Date()
                }, { merge: true }).then(() => {
                    console.log(``)
                    this.setState({
                        messageSent: true
                    })
                }).catch((err) => {
                console.log(`${err}`)
            })
        }).catch((err) => {
            console.log(`Update orders with id: ${this.props.orderID} with error: ${err}`)
        })
    }).catch((err) => {
        console.log(`Update orders with id: ${this.props.orderID} with error: ${err}`)
    })

        // used https://stackoverflow.com/questions/51995070/post-data-to-a-google-form-with-ajax
        // for new forms don't forget to set url permissions
        // let formId = "1FAIpQLSfCO6VXpweDwfWJlbqfwdk4uAYuJ5ezIKqhVceyM0RxaZLUrw"
        // let url = `https://docs.google.com/forms/d/e/${formId}/formResponse?usp=pp_url`
        // url += `&entry.1449536649=${this.props.UID}`
        // url += `&entry.1954028070=${this.props.actionID}`
        // url += `&entry.1138518334=${this.props.title}`
        // url += `&entry.1761877687=${this.state.comment}&submit=Submit`
        // axios.get(
        //   url,
        //   {
        //     data: {},
        //     headers: {
        //       'Content-Type': 'application/x-www-form-urlencoded'
        //     }
        //   }
        // ).then((res) => console.log(res)).catch((err) => {
        //   // data sent even with cors error
        //   console.log(err)

        //   // update firestore document with PENDING and comment
        //   db.collection("TEST-actions-list").doc(this.props.actionID).set({
        //     status: "pending",
        //     comment: this.state.comment,
        //     updatedAt: new Date()
        //   }, {merge: true}).then(() => {
        //     console.log(`Update TEST-actions-list with id: ${this.props.actionID}`)
        //     this.setState({
        //       comment: '',       
        //       messageSent: true
        //     })       
        //   }).catch((err) => {
        //     console.log(`Update TEST-actions-list with id: ${this.props.actionID} with error: ${err}`)
        //   })

        // })
    }

    loadData = () => {
        let usersData = this.props.users.dataRows.map((prop, key) => {
            let colObj = { ...prop }
            const volUID = colObj.volUID
            const username = colObj.username
            // Load Data for Summary Cards and add buttons     
            return {
                ...colObj,
                // status: (<span style={{ color: "red" }}>assigned</span>),
                id: key
            }
        })

        this.setState({
            usersData,
            dataLoaded: true
        })
        //console.log(usersData)
    }

    resetRequest = () => {
        window.location.reload();
    }

    render() {
        const { classes, modalClose, orderID, AuthBool, authUser } = this.props;
        const userTypes = ['', 'Shipper', 'Carrier', 'User', 'Admin']

        if (this.props.users.dataLoaded
            && !this.state.dataLoaded) {
            this.loadData()
        }

        // reset modal when closed
        if (modalClose && this.state.messageSent) { this.resetRequest() }

        return (
            <div>
                {this.state.messageSent ? (
                    <GridContainer justify="center">
                        <GridItem xs={11}>
                            <h4 className={classes.textPrimary}>Action Submitted!</h4>
                        </GridItem>
                    </GridContainer>
                ) : (
                        <div className={classes.formContainer}>
                            <form onSubmit={this.handleSubmit}
                            >
                                <GridContainer justify="center">
                                    <GridItem xs={11}>
                                        <h5 className={classes.bodyText}>{orderID ? orderID : null}</h5>
                                        <h5 className={classes.bodyText}>Choose the logistic partners</h5>
                                        {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error</h5> : null}
                                        <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                                htmlFor="pickUpCarrier"
                                                className={classes.selectLabel}>
                                                Pick Up:
                    </InputLabel>
                                            <Select
                                                MenuProps={{
                                                    className: classes.selectMenu
                                                }}
                                                classes={{
                                                    select: classes.select
                                                }}
                                                value={this.state.pickUpCarrier}
                                                onChange={this.handleSelectChange}
                                                inputProps={{
                                                    id: 'pickUpCarrier',
                                                    name: 'pickUpCarrier'
                                                }}
                                            >
                                                {this.state.usersData ?
                                                    this.state.usersData.map((item) => (
                                                        <MenuItem
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}
                                                            value={item.volUID}
                                                            key={item.volUID}
                                                        >{item.username}</MenuItem>
                                                    )) : null
                                                }
                                            </Select>
                                        </FormControl>

                                        <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                                htmlFor="dropOffCarrier"
                                                className={classes.selectLabel}>
                                                Drop Off:
                    </InputLabel>
                                            <Select
                                                MenuProps={{
                                                    className: classes.selectMenu
                                                }}
                                                classes={{
                                                    select: classes.select
                                                }}
                                                value={this.state.dropOffCarrier}
                                                onChange={this.handleSelectChange}
                                                inputProps={{
                                                    id: 'dropOffCarrier',
                                                    name: 'dropOffCarrier'
                                                }}
                                            >
                                                {this.state.usersData ?
                                                    this.state.usersData.map((item) => (
                                                        <MenuItem
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}
                                                            value={item.volUID}
                                                            key={item.volUID}
                                                        >{item.username}</MenuItem>
                                                    )) : null
                                                }
                                            </Select>
                                        </FormControl>


                                        <CustomInput
                                            labelText="Comment"
                                            id="comment"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                required: true,
                                                type: "text",
                                                multiline: true,
                                                rows: 5,
                                                onChange: (event) => this.handleChange(event)
                                            }}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <Button
                                    type="submit"
                                    color="primary"
                                    style={{
                                        marginLeft: "10px",
                                        marginBottom: "10px"
                                    }}
                                >
                                    SUBMIT
              </Button>
                            </form>
                        </div>

                    )}
            </div>
        );
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        users: state.admin.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        startSetCarriersList: dispatch(startSetCarriersList())
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(Form);


// WEBPACK FOOTER //
// ./src/components/Forms/DispatchForm.jsx